import { render, staticRenderFns } from "./default.vue?vue&type=template&id=28d81366"
import script from "./default.vue?vue&type=script&lang=js"
export * from "./default.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppHeader: require('/var/www/html/fantini/frontend-2/components/app/header/index.vue').default,AppFooter: require('/var/www/html/fantini/frontend-2/components/app/footer/index.vue').default,ModalMenu: require('/var/www/html/fantini/frontend-2/components/modal/menu/index.vue').default,ModalLoading: require('/var/www/html/fantini/frontend-2/components/modal/loading/index.vue').default,AppCurtain: require('/var/www/html/fantini/frontend-2/components/app/curtain/index.vue').default})
